if (!customElements.get('grid-switcher')) {
  class GridSwitcher extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.switcher-track');
      this.buttons = this.querySelectorAll('[data-grid-cols]');
      
      const savedCols = localStorage.getItem('taiga_mobile_grid_cols') || '1';
      this.applyGridCols(savedCols, false);

      this.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const currentCols = this.getAttribute('data-active') || localStorage.getItem('taiga_mobile_grid_cols') || '1';
        const nextCols = currentCols === '1' ? '2' : '1';
        this.applyGridCols(nextCols, true);
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          const currentCols = this.getAttribute('data-active') || localStorage.getItem('taiga_mobile_grid_cols') || '1';
          const nextCols = currentCols === '1' ? '2' : '1';
          this.applyGridCols(nextCols, true);
        }
      });

      // Efficient debounced observer for AJAX re-renders
      this.onDomChange = this.debounce(() => {
        const currentGrid = document.getElementById('product-grid-ajax');
        if (currentGrid) {
          const activeCols = localStorage.getItem('taiga_mobile_grid_cols') || '1';
          if (activeCols === '2' && !currentGrid.classList.contains('mobile-grid-2')) {
            currentGrid.classList.remove('mobile-grid-1');
            currentGrid.classList.add('mobile-grid-2');
          } else if (activeCols === '1' && !currentGrid.classList.contains('mobile-grid-1')) {
            currentGrid.classList.remove('mobile-grid-2');
            currentGrid.classList.add('mobile-grid-1');
          }
        }
      }, 50);

      const ajaxContainer = document.getElementById('collection-ajax') || document.body;
      this.observer = new MutationObserver(this.onDomChange);
      this.observer.observe(ajaxContainer, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    debounce(fn, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    applyGridCols(cols, save = true) {
      this.setAttribute('data-active', cols);
      
      if (this.track) {
        this.track.setAttribute('aria-checked', cols === '2' ? 'true' : 'false');
      }

      this.buttons.forEach((btn) => {
        const isTarget = btn.getAttribute('data-grid-cols') === cols;
        if (isTarget) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

      const grid = document.getElementById('product-grid-ajax');
      if (grid) {
        if (cols === '2') {
          grid.classList.remove('mobile-grid-1');
          grid.classList.add('mobile-grid-2');
        } else {
          grid.classList.remove('mobile-grid-2');
          grid.classList.add('mobile-grid-1');
        }
      }

      if (save) {
        try {
          localStorage.setItem('taiga_mobile_grid_cols', cols);
        } catch (e) {
          // Fallback for private browsing mode storage quota exceptions
        }
      }
    }
  }

  customElements.define('grid-switcher', GridSwitcher);
}

// Global handler for sort dropdown text sync
document.addEventListener('change', (e) => {
  if (e.target && e.target.matches('[data-sort-by-select]')) {
    const wrapper = e.target.closest('.sort-by-wrapper');
    if (wrapper) {
      const textSpan = wrapper.querySelector('[data-sort-current-text]');
      if (textSpan && e.target.selectedIndex >= 0) {
        textSpan.textContent = e.target.options[e.target.selectedIndex].text;
      }
    }
  }
});
